import note from './note';
const ajaxurl = loschlegal.ajaxurl;
const ajaxnonce = loschlegal.ajaxnonce;

const request = async (data) => {
    try {
        const response = await fetch(ajaxurl, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
                'X-WP-Nonce': ajaxnonce,
            },
            body: new URLSearchParams(data).toString()
        });

        if (!response.ok) {
            throw new Error(`Request failed with status ${response.status}`);
        }

        const result = await response.json();
        process(data.callback, result);

    } catch (error) {
        console.error('Request error:', error);
        note('It seems there was an error with your request. Please try again later or contact support for assistance.');
    }
};

// Process server response
const process = (callback, response) => {
    const loader = document.querySelector('.loschlegal-loader');
    
    const responseHandlers = {
        _comment: () => {},
        _filterByTax: () => {
            const filter = document.querySelector('.c-filters__inner');
            const filterPages = document.querySelector('.c-filters__paged')
            console.log(response);
            if( filter ) {
                filter.innerHTML = response.html;
            }
            if( filterPages ) {
                filterPages.innerHTML = response.pages;
            }
        },
        default: () => {}
    };

    if (loader) loader.remove();

    // Call the relevant handler or default if not found
    (responseHandlers[callback] || responseHandlers.default)();

    // Display a note if provided in the response, otherwise a default message
    // note(response.note || 'Action completed successfully.');
    note(response.note || '');
};

export default request;